import moment from "moment";
import { ActionContext } from "vuex";
import { WalletStateInterface } from "./types";
import VuetifySelectItems from '@/types/app/vuetifySelectItems';

moment.locale("en-US");
export default {  
  
  setSelectProductsState(
    store: ActionContext<WalletStateInterface, any>,
    selectProducts: VuetifySelectItems[]
  ) {
    store.commit("setSelectProductsState", selectProducts);
  },
  setSelectFundsState(
    store: ActionContext<WalletStateInterface, any>,
    selectFunds: VuetifySelectItems[]
  ) {
    store.commit("setSelectFundsState", selectFunds);
  },
};

